import {
  ChangeDetectorRef,
  Component,
  Inject,
  effect,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AppStateService } from 'src/app/core/services/app-state.service';
import { ClientDataInitializerService } from 'src/app/core/services/authentication/client-data-initializer.service';
import { SendTypes } from '../../../core/api/models/send-types';

@Component({
    selector: 'app-send-sms-confirmation',
    templateUrl: './send-sms-confirmation.component.html',
    styleUrls: ['./send-sms-confirmation.component.scss'],
    standalone: false
})
export class SendSmsConfirmationComponent {
  appStateService = inject(AppStateService);
  pageVocabs = 'pages.sendQueue.fields.';

  model: any;
  sendType: SendTypes;
  get SendTypes() {
    return SendTypes;
  }
  isEdit: boolean;
  // theme: AppThemeMode;
  mciImage: string;
  rightelImage: string;
  agentLogo: string;
  senderNumber: number;

  selectedMode: any = 'ios';

  constructor(
    private dialogRef: MatDialogRef<SendSmsConfirmationComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clientDataService: ClientDataInitializerService
  ) {
    this.model = data?.model;
    this.sendType = data?.sendType;
    this.isEdit = data?.isEdit;
    this.senderNumber = data?.privateNumber;
    effect(() => {
      this.mciImage =
        this.appStateService.currentThemeMode() == 'dark'
          ? '/assets/media/svg/operator/mci-dark.svg'
          : '/assets/media/svg/operator/mci.svg';
      this.rightelImage =
        this.appStateService.currentThemeMode() == 'dark'
          ? '/assets/media/svg/operator/rightel-dark.svg'
          : '/assets/media/svg/operator/rightel.svg';
    });
  }
  ngOnInit() {
    this.agentLogo = this.clientDataService.getCurrentClientData?.agentLogo;
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSubmit() {
    this.dialogRef.close(true);
  }

  onChangeMode(event) {
    this.selectedMode = event;
  }
}
